import { DatePipe } from '@angular/common';
import {
  Inject,
  Injectable,
  LOCALE_ID,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TranslatorService } from '../services/translator';

@Pipe({
  name: 'localeDate',
  pure: false,
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class LocaleDatePipe extends DatePipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) locale: string,
    private readonly translatorService: TranslatorService
  ) {
    super(locale);
  }

  transform(
    value: string | number | Date,
    format?: string,
    timezone?: string
  ): any {
    return this.translatorService.getCurrentLang().pipe(
      map((newFormattedLang) =>
        super.transform(value, format, timezone, newFormattedLang)
      ),
      catchError((error) => {
        console.warn('Locale Date Pipe :', error);
        return of(value.toString());
      })
    );
  }

  getInstantTransform(
    value: string | number | Date,
    format?: string,
    timezone?: string
  ) {
    const formattedLang = this.translatorService.getCurrentLang().getValue();
    try {
      return super.transform(value, format, timezone, formattedLang);
    } catch (error) {
      console.warn('Locale Date Pipe :', error);
      return value.toString();
    }
  }
}
